import { NavigationTemplateProps } from '../../sidemenu/templates/NavigationTemplateProps';

export const corporateNavigation = (props: NavigationTemplateProps) => {
  return [
    {
      text: 'Home page',
      link: '/homepage',
      icon: 'menuHome',
      classname: '',
      isVisible: true,
    },
    {
      text: 'Sustainability Hub',
      link: '/substainabilityHub',
      icon: 'menuSustainabilityHub',
      classname: '',
      isVisible: true,
    },
    {
      text: 'My Messages',
      link: '/messages',
      icon: 'menuMessages',
      classname: '',
      isVisible: true,
    },
    {
      text: 'My Documents',
      link: '/document',
      icon: 'menuDocuments',
      classname: '',
      isVisible: true,
    },
    {
      text: 'Account details',
      link: '/account',
      icon: 'menuAccount',
      classname: '',
      isVisible: true,
    },
    {
      text: 'MPANs',
      link: '/mpans',
      icon: 'menuMPAN',
      classname: '',
      isVisible: true,
    },
    {
      text: 'My invoices',
      link: '/myinvoices',
      icon: 'menuInvoicePayment',
      classname: '',
      isVisible: true,
    },
    {
      text: 'Payments',
      link: '/Payments',
      icon: 'menuPayment',
      classname: '',
      isVisible: true,
    },
    {
      text: 'Energy usage',
      link: '/Energyusage',
      icon: 'menuData',
      classname: '',
      isVisible: true,
    },
    {
      text: 'Scheduled Reporting',
      link: '/ScheduledReporting',
      icon: 'menuScheduledReporting',
      classname: '',
      isVisible: true,
    },
    {
      text: 'Exclusive Offers',
      link: '/ExclusiveOffers',
      icon: 'menuOffers',
      classname: '',
      isVisible: true,
    },
    {
      text: 'Our insights',
      link: '/OurInsights',
      icon: 'menuOurInsights',
      classname: '',
      isVisible: true,
    },
  ];
};
